const PARAMS_STORAGE_KEY = "initialQueryParams";
const REFERRER_STORAGE_KEY = "referrer";

export type QueryParams = Record<string, string>;

/**
 * Captures query parameters from the current URL and stores them in SessionStorage.
 * Only stores on the first call to preserve the original landing URL params.
 */
export const captureQueryParams = () => {
  if (sessionStorage.getItem(PARAMS_STORAGE_KEY)) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const queryParams: QueryParams = {};

  params.forEach((value, key) => {
    queryParams[key.toLowerCase()] = value;
  });

  sessionStorage.setItem(PARAMS_STORAGE_KEY, JSON.stringify(queryParams));
};

export const catureReferrer = () => {
  sessionStorage.setItem(REFERRER_STORAGE_KEY, window.document.referrer);
};

export const getStoredQueryParams = (
  whitelist?: string[],
  fallback?: any,
): QueryParams => {
  const stored = sessionStorage.getItem(PARAMS_STORAGE_KEY);
  if (!stored) {
    return fallback || {};
  }

  try {
    const parsedParams = JSON.parse(stored) as QueryParams;

    const returnedParams: QueryParams = {};

    Object.keys(parsedParams).forEach((key) => {
      if (whitelist && !whitelist.includes(key.toLowerCase())) {
        return;
      }

      returnedParams[key.toLowerCase()] = parsedParams[key];
    });

    return returnedParams;
  } catch {
    return fallback || {};
  }
};

export const getReferrer = (): string | null => {
  return sessionStorage.getItem(REFERRER_STORAGE_KEY);
};

export const getStoredQueryParam = (key: string): string | undefined => {
  return getStoredQueryParams()[key];
};
